export default __webpack_public_path__ + "201c1922d3668c65682930979b9ca6df.png";